import { Utils } from 'cc-common';
import dxValidator from 'devextreme/ui/validator';
import { Subject } from 'rxjs';
import { IContextInfo, IWidgetSize } from '../_interfaces/dynamic-dashboard-data-models';
import { EntitySelectorResultDto } from '../../cirabooks/shared-cirabooks-module/_models/common/enity-selector-result-dto';

export class DynamicDashboardItem {
    widgetEntityChanged: Subject<EntitySelectorResultDto> = new Subject();
    widgetContextChanged: Subject<IContextInfo> = new Subject();
    widgetSizeChanged: Subject<IWidgetSize> = new Subject();
    titleUpdate: Subject<boolean> = new Subject();

    id: number;
    title: string;
    helpLink: string;
    widthRatio: number;
    heightRatio: number;
    widgetId: string;
    minWidthRatio: number;
    minHeightRatio: number;
    minWidth: number;
    minHeight: number;
    hideFullScreen: boolean;

    isFullScreen: boolean;
    isConfigVisible: boolean;
    loadingVisible: boolean;
    originalWidgetId: string;
    calcMinWidthRatio: number;
    calcMinHeightRatio: number;
    selectedContext: IContextInfo;
    widgetValidator: dxValidator;
    selectedEntity: EntitySelectorResultDto;

    get widgetChanged(): boolean {
        return Utils.notNullAndDefined(this.originalWidgetId) && Utils.notEquals(this.originalWidgetId, this.widgetId);
    }

    updateWidgetContext(communityId: number, managementCompanyId: number, communityName: string): void {
        this.selectedContext = { communityId, managementCompanyId, communityName };
        if (
            Utils.notNullAndDefined(this.selectedContext) &&
            Utils.notNullAndDefined(this.selectedContext.communityId)
        ) {
            this.widgetContextChanged.next(this.selectedContext);
        }
    }

    updateWidgetEntity(entityId: number, name: string): void {
        this.selectedEntity = { entityId, name };
        if (Utils.notNullAndDefined(this.selectedEntity) && Utils.notNullAndDefined(this.selectedEntity.entityId)) {
            this.widgetEntityChanged.next(this.selectedEntity);
        }
    }

    validate(): boolean {
        if (Utils.notNullAndDefined(this.widgetValidator)) {
            this.widgetValidator.validate();
        }
        return Utils.notNullAndDefined(this.widgetId);
    }

    refresh(width?: number, height?: number): void {
        const widgetSize = { width, height };
        this.widgetSizeChanged.next(widgetSize);
    }

    updateTitle(): void {
        this.titleUpdate.next(true);
        if (
            Utils.notNullAndDefined(this.selectedContext) &&
            Utils.notNullAndDefined(this.selectedContext.communityId)
        ) {
            this.widgetContextChanged.next(this.selectedContext);
        }

        if (Utils.notNullAndDefined(this.selectedEntity) && Utils.notNullAndDefined(this.selectedEntity.entityId)) {
            this.widgetEntityChanged.next(this.selectedEntity);
        }
    }
}
